module.exports = __webpack_public_path__ + "static/img/project4.b881a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project4.png
// module id = 6lcA
// module chunks = 1